"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useWriteUserVehicleService = exports.useReadUserVehicleService = void 0;
var _reactQuery = require("@tanstack/react-query");
var _eos = _interopRequireDefault(require("../../clients/eos"));
var _index = require("../../clients/eos/index.enum");
var _useAnalyticsReporting = require("../../utils/hooks/useAnalyticsReporting");
var _withAxiosResponseValidation = require("../common/higher-order-functions/with-axios-response-validation");
var _withInputValidation = require("../common/higher-order-functions/with-input-validation");
var _index2 = require("./validation/AddVehicle/index.schema");
var _index3 = require("./validation/RemoveVehicle/index.schema");
var _index4 = require("./validation/UpdateVehicle/index.schema");
// TODO: Investigate how to clean-up via query-key factory
const initWithCancelUserVehiclesQuery = function (queryClient) {
  return function (fn) {
    return async function () {
      await queryClient.cancelQueries(["user-vehicles"]);
      return fn(...arguments);
    };
  };
};
const BASE_PATH = "/v1/customer/vehicles";
/**
 * TODO:
 * - Bring Read & Write UserVehicle Service together when analytics are supported in PersonalizationProvider
 */
const useReadUserVehicleService = function () {
  const eosClient = (0, _eos.default)();

  /**
   * TODO:
   * - Return validated Find Method when API response validation is standardized across all findUserVehicles calls
   * - Add Analytics Reporting for Success/Failure reporting on this call when Personalization Provider can handle analytics reporting
   */
  const find = function (config) {
    return eosClient.get(BASE_PATH, {
      includeAuth: true,
      includeReCaptcha: true,
      service: _index.EOSEndpoint.vehicleManagement,
      ...config
    });
  };
  return {
    find
  };
};
exports.useReadUserVehicleService = useReadUserVehicleService;
const useWriteUserVehicleService = function () {
  const queryClient = (0, _reactQuery.useQueryClient)();
  const eosClient = (0, _eos.default)();
  const withCancelUserVehiclesQuery = initWithCancelUserVehiclesQuery(queryClient);
  const addVehicleByModelYear = (0, _withAxiosResponseValidation.withAxiosResponseValidation)(function (_ref) {
    let {
      model,
      year
    } = _ref;
    return eosClient.post(BASE_PATH, {
      modelYearList: [{
        model,
        year
      }],
      VinList: []
    }, {
      includeAuth: true,
      includeReCaptcha: true,
      service: _index.EOSEndpoint.vehicleManagement
    });
  }, _index2.AddVehicleByModelYearResponseSchema);
  const addVehicleByVin = (0, _withAxiosResponseValidation.withAxiosResponseValidation)(function (_ref2) {
    let {
      vin
    } = _ref2;
    return eosClient.post(BASE_PATH, {
      modelYearList: [],
      VinList: [{
        vin
      }]
    }, {
      includeAuth: true,
      includeReCaptcha: true,
      service: _index.EOSEndpoint.vehicleManagement
    });
  }, _index2.AddVehicleByVinResponseSchema);
  const add = (0, _useAnalyticsReporting.useAnalyticsReporting)(withCancelUserVehiclesQuery(function (payload) {
    return "vin" in payload ? addVehicleByVin(payload) : addVehicleByModelYear(payload);
  }), {
    name: "addVehicle"
  });
  const remove = (0, _useAnalyticsReporting.useAnalyticsReporting)(withCancelUserVehiclesQuery((0, _withInputValidation.withInputValidation)(function (_ref3) {
    let {
      vehicleId,
      ...rest
    } = _ref3;
    return eosClient.delete(`${BASE_PATH}/${vehicleId}`, {
      includeAuth: true,
      params: rest,
      service: _index.EOSEndpoint.vehicleManagement
    });
  }, _index3.RemoveVehicleRequestSchema)), {
    name: "removeVehicle"
  });
  const update = (0, _useAnalyticsReporting.useAnalyticsReporting)(withCancelUserVehiclesQuery((0, _withInputValidation.withInputValidation)(function (_ref4) {
    let {
      vehicleId,
      ...rest
    } = _ref4;
    return eosClient.patch(`${BASE_PATH}/${vehicleId}`, rest, {
      includeAuth: true,
      includeReCaptcha: true,
      service: _index.EOSEndpoint.vehicleManagement
    });
  }, _index4.UpdateVehicleRequestSchema)), {
    name: "updateVehicle"
  });
  return {
    add,
    remove,
    update
  };
};
exports.useWriteUserVehicleService = useWriteUserVehicleService;